import { Component } from 'react'
import { extendObservable, asStructure } from 'mobx'
import { observer } from 'mobx-react'

import * as h from 'h'

import Switch from './Switch'

import styles from './styles.scss'

// SwitchFilters can be a controlled or uncontrolled form-like component
// For a controlled component, supply it with a values prop list with
// an 'active' flag for each item
// For an uncontrolled component, supply it with an options prop list

@observer
export default class SwitchFilters extends Component {
  // --------------------------------------------------------------------------
  // Lifecycle
  // --------------------------------------------------------------------------

  componentWillMount () {
    if (this.props.options) {
      // Component is uncontrolled, so we must
      // maintain a list of active items

      const initialActives = this.props.options
        .filter(({ initial }) => initial)
        .map(({ slug, name }) => (slug || name))

      extendObservable(this, {
        active: asStructure(initialActives)
      })
    }
  }

  // --------------------------------------------------------------------------
  // Actions
  // --------------------------------------------------------------------------

  onChange (slug) {
    if (this.props.options) {
      // Uncontrolled

      if (this.active.includes(slug)) {
        this.active = this.active.filter(a => a !== slug)
      } else {
        this.active.push(slug)
      }

      this.props.onChange(this.active.toJS())
    } else if (this.props.values) {
      // Controlled

      this.props.onChange(this.props.values.map(item => ({
        ...item,
        active: ((item.slug || item.name) === slug) ? !item.active : item.active
      })))
    }
  }

  // --------------------------------------------------------------------------
  // Render
  // --------------------------------------------------------------------------

  render () {
    const { options, values } = this.props

    const switches = (options || values).map(({ name, slug, brand, active }) =>
      h.h(Switch, {
        key: slug || name,
        name,
        brand,
        active: this.props.options ? this.active.includes(slug || name) : active,
        onChange: () => this.onChange(slug || name)
      }))

    return h.div(h.ca(styles.wrapper), switches)
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/SwitchFilters/index.js